
global.moment = require('moment');

require('./libraries/bootstrap');

// require('signature_pad/dist/signature_pad');

// import * as SignaturePad from 'signature_pad';

require('./ui-kit/show-password');

require('./ui-kit/password-meter');

require('./ui-kit/confirmation');

require('select2/dist/js/select2.full');

require('datatables.net');

require('datatables.net-bs4');

require('jquery-mask-plugin');

require('jquery-validation');

require('tempusdominus-bootstrap-4');

require('./ui-kit/preloader');

require('./ui-kit/handlebar');

require('./ui-kit/mobile-menu');

require('./ui-kit/export-datatable');

require('./ui-kit/create-query');

require('./ui-kit/global');

require('./ui-kit/table-top-scroll');

require('jquery-jscroll');

import { notification } from "./helpers/notification";
window.notification = notification




